"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textToDate = exports.dateToText = exports.textToRange = exports.rangeToText = void 0;

var _format = _interopRequireDefault(require("date-fns/format"));

var _parse = _interopRequireDefault(require("date-fns/parse"));

var _isValid = _interopRequireDefault(require("date-fns/isValid"));

var _startOfDay = _interopRequireDefault(require("date-fns/startOfDay"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var DATE_FORMAT = 'MM/dd/yy';

var rangeToText = function rangeToText(startDate, endDate) {
  return "".concat((0, _format.default)(startDate, DATE_FORMAT), " - ").concat((0, _format.default)(endDate, DATE_FORMAT));
};

exports.rangeToText = rangeToText;

var textToRange = function textToRange(text) {
  var _text$split$map = text.split('-').map(function (v) {
    return v.trim();
  }),
      _text$split$map2 = _slicedToArray(_text$split$map, 2),
      startDateText = _text$split$map2[0],
      endDateText = _text$split$map2[1];

  if (startDateText && _lodash.default.size(startDateText) === 8 && endDateText && _lodash.default.size(endDateText) === 8) {
    var startDate = (0, _parse.default)(startDateText, DATE_FORMAT, (0, _startOfDay.default)(new Date()));
    var endDate = (0, _parse.default)(endDateText, DATE_FORMAT, (0, _startOfDay.default)(new Date()));
    return [startDate, endDate];
  }

  return [null, null];
};

exports.textToRange = textToRange;

var dateToText = function dateToText(date) {
  return (0, _format.default)(date, DATE_FORMAT);
};

exports.dateToText = dateToText;

var textToDate = function textToDate(text) {
  if (_lodash.default.size(text) === 8) {
    var date = (0, _parse.default)(text, DATE_FORMAT, (0, _startOfDay.default)(new Date()));
    if ((0, _isValid.default)(date)) return date;
  }

  return null;
};

exports.textToDate = textToDate;